import { render, staticRenderFns } from "./blayer.vue?vue&type=template&id=15ad4012&scoped=true"
import script from "./blayer.vue?vue&type=script&lang=js"
export * from "./blayer.vue?vue&type=script&lang=js"
import style0 from "./blayer.vue?vue&type=style&index=0&id=15ad4012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad4012",
  null
  
)

export default component.exports